import React from 'react'
import PermittedConfirmModelAction from 'support/actions/PermittedConfirmModelAction'

export default function Delete () {
  return (
    <PermittedConfirmModelAction operation='delete' label='Slet' confirmProps={{ confirm: 'Slet', cancel: 'Annuller' }} refreshModel={false}>
      <p>Er du sikker på du vil slette?</p>
    </PermittedConfirmModelAction>
  )
}
